
import SidebarIcon1 from '../../../Marketing/BuisnessDashboard/Images/SidebarIcon1.svg'
import SidebarIcon11 from '../../../Marketing/BuisnessDashboard/Images/SidebarIcon11.svg'

import SidebarIcon88 from '../../../Marketing/BuisnessDashboard/Images/SidebarIcon88.svg'
import SidebarIcon8 from '../../../Marketing/BuisnessDashboard/Images/SidebarIcon8.svg'


const SidbarContent = [
    { text: "Dashboard", icon: SidebarIcon11, selectedIcon: SidebarIcon1, ShowType: "dashboard", subType: [] },
    {
        text: "Scheduled NACH", icon: SidebarIcon88, selectedIcon: SidebarIcon8, ShowType: "scheduledNach", subType: []
    },
]

export default function Sidebar({ handleTabType, isSidebarOpen, activeTab, activeSubTab }) {
    return (
        <>
            <div className='Sidebar-content'>
                <ul className='sidebar-top-level-ul'>
                    {
                        SidbarContent?.length > 0 ? SidbarContent?.map((val, id) => {
                            return (
                                <li style={{marginBottom:window.innerWidth > 1800 ? "10px" : ""}}>
                                    <div className={`heading ${val?.ShowType == activeTab ? "active" : ""} ${isSidebarOpen ? "expanded" : ""}`} onClick={() => handleTabType(val, "activeTab")}>
                                        <img src={val?.ShowType == activeTab ? val?.selectedIcon : val?.icon} />
                                        <h5 className='sidebar-text'>
                                            {val?.text}
                                        </h5>
                                    </div>
                                    {
                                        val?.ShowType == activeTab && val?.subType?.length > 0 && isSidebarOpen ?
                                            <div className='sub-items'>
                                                <ul>
                                                    {
                                                        val?.subType?.map((subVal, ids) => {
                                                            return (
                                                                <li key={ids}>
                                                                    <div className={`subHeading ${subVal?.ShowType == activeSubTab ? "active" : ""}`} onClick={() => handleTabType(subVal?.ShowType, "activeSubTab")}>
                                                                        <h6>{subVal?.text}</h6>
                                                                    </div>
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                            : ""}
                                </li>
                            )
                        })
                            : ""}
                </ul>
            </div>
        </>
    )
}
